export function sanitizeInternalReturnTo(value: string | null | undefined): string | null {
  const raw = String(value || '').trim();
  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return null;
  }
  return raw;
}

export function buildKnowledgeParticleDetailPath(
  particleId: string,
  returnTo?: string | null,
): string {
  const path = `/knowledge/${encodeURIComponent(particleId)}`;
  const safeReturn = sanitizeInternalReturnTo(returnTo);
  if (!safeReturn) {
    return path;
  }
  return `${path}?returnTo=${encodeURIComponent(safeReturn)}`;
}

export function resolveKnowledgeParticleBackLink(searchParams: URLSearchParams): {
  to: string;
  label: string;
} {
  const safeReturn = sanitizeInternalReturnTo(searchParams.get('returnTo'));
  if (safeReturn) {
    if (safeReturn.includes('/ttqworkbench/')) {
      return { to: safeReturn, label: '← 返回品题工作台' };
    }
    if (/\/ttq\/[^/]+\/ipttq\//.test(safeReturn)) {
      return { to: safeReturn, label: '← 返回品题浓缩结果详情' };
    }
    if (safeReturn.includes('view=birds-eye')) {
      return { to: safeReturn, label: '← 返回品题鸟瞰' };
    }
    if (safeReturn.includes('/ttq/')) {
      if (safeReturn.includes('addParticle=1')) {
        return { to: safeReturn, label: '← 返回添加知识颗粒' };
      }
      return { to: safeReturn, label: '← 返回品题画布' };
    }
    return { to: safeReturn, label: '← 返回' };
  }
  return { to: '/knowledge', label: '← 返回列表' };
}
